import gql from 'graphql-tag';

export const GET_USERS = gql`
  query getUsers($user_type: String!, $includeChildren: Boolean!) {
    users(
      where: {
        user_type: { _eq: $user_type }
        _or: [{ deleted: { _is_null: true } }, { deleted: { _neq: true } }]
      }
    ) {
      user_email
      user_phone
      user_first_name
      user_id
      user_last_name
      user_cognito_username
      user_status
      user_preferred_name
      children: guardian_children @include(if: $includeChildren) {
        student_id
        student {
          user_id
          user_first_name
          user_last_name
        }
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($userId: Int!, $data: users_set_input!) {
    update_users(where: { user_id: { _eq: $userId } }, _set: $data) {
      returning {
        user_email
        user_first_name
        user_id
        user_last_name
        user_preferred_name
      }
    }
  }
`;

export const UPCOMING_MEETINGS = gql`
  query getUpcoming(
    $start: timestamptz!
    $end: timestamptz
    $type: [String!]
    $coach: student_profile_bool_exp
  ) {
    rows: student_milestone_exercises(
      where: {
        _and: [
          {
            exercise: { type: { _eq: "meeting" }, meeting_type: { _in: $type } }
          }
          {
            status: { _eq: "inprogress" }
            student_milestone: { user: { student_profiles: $coach } }
          }
          { due_date: { _gte: $start } }
          { due_date: { _lte: $end } }
        ]
      }
      order_by: [{ due_date: asc }]
    ) {
      id
      due_date
      status
      response
      user_id
      user {
        user_first_name
        user_last_name
        name
      }
      exercise {
        name
        meeting_type
      }
    }
  }
`;

export const GET_USER_BY_EMAIL = gql`
  query getUsersByEmail($email: String!) {
    users(where: { user_email: { _eq: $email } }) {
      user_id
      user_email
      user_phone
      user_first_name
      user_last_name
      user_type
    }
  }
`;

export const GET_USER = gql`
  query getUser($id: Int!) {
    user: users_by_pk(user_id: $id) {
      id: user_id
      sub: user_cognito_sub
      user_id
      user_email
      user_phone
      user_first_name
      user_last_name
      user_preferred_name
      gender_pronounce
      timezone
    }
  }
`;
